import Controller, { OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../../BaseController';
import { FragmentNames, GastherapyTerminateAliases } from '../../../../../codegen';
import { Inject } from '@odinjs/odin';
import { FormAPI, ModalService } from '@philips-internal/oswald-ui-components';
import GastherapyService, { GastherapyItemStatus, GastherapyProps } from '../gastherapy-service';
import { DateFilterUtils } from '../../../../../utils/date-filter-utils';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import TimelineContext, { TimeLineEventMedication } from '../../../services/timeline-service';
import { ApplicationRoute } from '../../../../../constants/routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import MedicationService from '../../../../../controllers/adep/services/medication-service';

@Controller({ component: GastherapyTerminateAliases.TERMINATE_GASTHERAPY_LAYOUT, fragment: FragmentNames.GASTHERAPY_TERMINATE })
export default class GastherapyTerminateController extends BaseController {

  @Inject(GastherapyTerminateAliases.FORM_CONTENT)
  private formApi!: FormAPI;

  @OnMount(GastherapyTerminateAliases.FORM_CONTENT)
  onFormMount(): void {
    const timelineItemDetail = TimelineContext.get() as TimeLineEventMedication;
    const gastherapyInfo = this.context.getBulkData() as GastherapyProps;
    const messageTypeGas = MessageService.translate('text.type-of-gas');
    const messageTypeBreathing = MessageService.translate('tws.label-respiration-type');
    const messageVentilatorMod = MessageService.translate('tws.label-ventilator-mod');
    const observation = `${messageTypeGas}: ${timelineItemDetail.description}
${messageVentilatorMod}: ${gastherapyInfo.respiratoryModality}
${messageTypeBreathing}: ${gastherapyInfo.breathingType}`;

    this.formApi.setData({
      currentDateTime: DateFilterUtils.getCurrentDateTimeUtc(),
      observation
    })
  }

  @OnSubmit(GastherapyTerminateAliases.FORM_CONTENT)
  onFormSubmit(): void {
    this.isLoading(true);
    this.terminateGasTherapy();
  }

  private terminateGasTherapy(): void{
    const currentRecord = this.formApi.getValue();
    const timelineGastherapy = TimelineContext.get() as TimeLineEventMedication;

    const body = {
      dtChange: DateFilterUtils.getCurrentDateTimeUtc(),
      ieChange: GastherapyItemStatus.TERMINATE,
      justification: currentRecord.observation,
      prescriptionNumber: timelineGastherapy.prescriptionNumber,
      scheduleSeq: timelineGastherapy.id,
      seqGastherapy: timelineGastherapy.itemSequence,
      seqGastherapyCpoe: timelineGastherapy.cpoeSequence,
    } as Record<string, Value>;

    GastherapyService.generateGasTherapyChange(body)
      .then(() => {
        MedicationService.showToast('txt.item-terminate-with-success', ToastLevel.SUCCESS);
        this.isLoading(false);
        this.redirectUserToTimeline();
      }).catch((err) => {
        this.informationsCatch(err);
      })
  }

  private redirectUserToTimeline(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const redirectRoute = ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION;
    applicationContext.redirect(redirectRoute, { encounterId, patientId });
    applicationContext.clearNavigationStack();
    ModalService.close(FragmentNames.GASTHERAPY_TERMINATE);
  }

  private informationsCatch(error: any): void {
    this.isLoading(false);
    const hasError = !!error;

    if (!hasError) {
      return
    }
    if (error.body?.errors) {
      error?.body?.errors.forEach((message: string) => {
        MedicationService.showToast(message, ToastLevel.WARNING);
      })
      return;
    }
    if (error.body) {
      MedicationService.showToast(error.body, ToastLevel.ERROR);
    }
  }

  private isLoading(state: boolean): void {
    this.formApi.setLoading(state);
  }
}